module.exports = __webpack_public_path__ + "static/media/van side right.27e1ee02.png";